export const CHECK_DEVICE_RECORDS = 'CHECK_DEVICE_RECORDS'
export const CHECK_DEVICE_RECORDS_FULFILLED = 'CHECK_DEVICE_RECORDS_FULFILLED'
export const CHECK_DEVICE_RECORDS_REJECTED = 'CHECK_DEVICE_RECORDS_REJECTED'
